import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";

// Redirect the legacy /dashboard/inbox route to the Phase 5 messaging center.
export default function InboxPage() {
  const nav = useNavigate();
  useEffect(() => { nav("/dashboard/messages", { replace: true }); }, [nav]);
  return null;
}
